import changeHistoryExtension from './ChangeHistory'
import contextMenuActionsExtension from './ContextMenuActions'
import dataExtension from './Data'
import ioParserExtension from './IOParser'
import locationExtension from './Location'
import logsExtension from './Logs'
import metadataExtension from './Metadata'
import uiExtension from './UI'

export function XLSXParser() {
  this.index = 0
  this.rowHeaders = []
  this.columnHeaders = []
  this.undoHistory = []
  this.redoHistory = []
  this.metadata = {}
}

(Object.assign(XLSXParser.prototype,
  changeHistoryExtension, dataExtension, contextMenuActionsExtension, ioParserExtension,
  locationExtension, logsExtension, uiExtension, metadataExtension))

let helperInstance = new XLSXParser()
export default helperInstance